export default __webpack_public_path__ + "static/media/Error.9603678b.svg";